import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Standard from "../Standard";
import logo from "../../branding/current/logo.png";
import logoDark from "../../branding/current/logo_dark.png";

export class UnknownNumber extends React.Component {
  unknown = () => {
    return (
      <div className={"text-align-center margin-auto"}>
        <h1>{this.props.l10n("call.unknownnumber_uppercase")}</h1>
      </div>
    );
  };

  render() {
    const { contrast, l10n } = this.props;
    return (
      <Standard
        logo={logo}
        logoDark={logoDark}
        contrast={contrast}
        l10n={l10n}
        include={this.unknown()}
      />
    );
  }
}

UnknownNumber.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
});

export default connect(mapStateToProps)(UnknownNumber);






// WEBPACK FOOTER //
// ./src/kiosk/callStates/UnknownNumber.jsx